(function () {
  'use strict';

  var BADGE_STYLES = {
    wrapper: 'display:inline-flex;align-items:center;flex-wrap:wrap;gap:8px;font-family:var(--FONT-STACK-BODY);',
    zero: 'background:#000;color:#fff;padding:6px;border-radius:6px;font-weight:700;font-size:14px;letter-spacing:0.3px;line-height:1;',
    keep: 'color:var(--COLOR-TEXT, #1f2323);font-size:14px;line-height:1;'
  };

  function buildBadge(originalPrice) {
    var wrapper = document.createElement('span');
    wrapper.className = 'trynow-collection-badge';
    wrapper.setAttribute('style', BADGE_STYLES.wrapper);

    var zero = document.createElement('span');
    zero.setAttribute('style', BADGE_STYLES.zero);
    zero.textContent = '$0 NOW';

    var keep = document.createElement('span');
    keep.setAttribute('style', BADGE_STYLES.keep);
    keep.textContent = originalPrice + ' if you keep it';

    wrapper.appendChild(zero);
    wrapper.appendChild(keep);
    return wrapper;
  }

  function replacePrice(priceEl) {
    if (priceEl.dataset.trynowReplaced === 'true') return;
    var originalPrice = priceEl.textContent.trim();
    if (!originalPrice) return;
    priceEl.innerHTML = '';
    priceEl.appendChild(buildBadge(originalPrice));
    priceEl.dataset.trynowReplaced = 'true';
  }

  function replaceAll() {
    document.querySelectorAll('.product-grid-item__price').forEach(replacePrice);
  }

  function init() {
    replaceAll();

    // Re-run when new items load (infinite scroll, filter changes, etc.)
    var observer = new MutationObserver(function (mutations) {
      var needsUpdate = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          needsUpdate = true;
          break;
        }
      }
      if (needsUpdate) replaceAll();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
